import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const TipoOrigenPacienteView = lazy(() => import('../../container/configuracion/tipoOrigenPaciente/Index'));
const TipoOrigenPacienteForm = lazy(() => import('../../container/configuracion/tipoOrigenPaciente/Form'));

const TipoOrigenPacienteRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/catalogos/tipo-origen-paciente/listado`} component = { TipoOrigenPacienteView } />
             <Route path={`${path}/catalogos/tipo-origen-paciente/agregar`} component = { TipoOrigenPacienteForm } />
             <Route exact path = {`${path}/catalogos/tipo-origen-paciente/editar/:id`} component = { TipoOrigenPacienteForm } />
            </Switch>
  );
};

export default TipoOrigenPacienteRoute;

